export default "__VITE_ASSET__BtNcQ5H8__"